import { useSelector } from 'react-redux';
import { useAppSelector } from '~/hooks/useAppSelector';
import { useSelectedOffice } from '~/hooks/useSelectedOffice';
import { formatYears } from '../../../commonComponents/CommonFunctions';
import WarningAlertIcon from '../../../images/warning_alert_orange.svg';
import { Colors } from '../../../themes/colors';
import { EducationUtils } from '../../../utils/EducationUtils';
import { OfficeTypeEnum } from '../../../utils/Enum';
import { useCandidate } from '../../CandidateList/hooks/useCandidate';
import { getCompanyMatchLabel } from '../../CandidateList/utils';
import { ProfessionalAttestationInfo } from '../ProfessionalAttestationInfo';
import { DnDaProcedures } from './Procedures/DnDaProcedures';
import { RdhFdProcedures } from './Procedures/RdhFdProcedures';

export const CandidateInfo = ({ candidate, professionalInfo }) => {
  const job = useSelector((state) => state.job.job);
  const user = useSelectedOffice(job?.offer_owner?.id);
  const { specialtyMatch, userSpecialties } = useCandidate(user, candidate, job);
  const dsoOffice = useAppSelector((state) => state.dso.office);

  const isDSO = user?.office_info?.officeType === OfficeTypeEnum.DSO;
  const companyMatchLabel = getCompanyMatchLabel({
    averageRating: candidate?.average_rating,
    hasBadges: !!candidate?.badges?.length || candidate?.currentRank?.rank,
    hasWorkedWithDSO: candidate?.hasWorkedWithDSO,
    hasWorkedWithOffice: candidate?.hasWorkedWithOffice,
    isDSO,
    officeName: candidate?.hasWorkedWithDSO ? dsoOffice?.dso?.name : user?.office_name,
  });

  const exactYearsOfExperience = professionalInfo?.exactYearsOfExperience;
  const yoe =
    exactYearsOfExperience != null
      ? formatYears(exactYearsOfExperience)
      : candidate?.years_of_experience;

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          width: '100%',
          display: 'flex',
          columnGap: 5,
          justifyContent: 'space-between',
          marginTop: 4,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            rowGap: 20,
            width: '100%',
            padding: '16px 18px',
          }}
        >
          {companyMatchLabel && (
            <ProfessionalInfoSection
              title={companyMatchLabel.label}
              value={companyMatchLabel.text}
            />
          )}

          <ProfessionalAttestationInfo consent={candidate?.consent} />

          <ProfessionalInfoSection title="Years of Experience" value={yoe} />

          <ProfessionalInfoSection
            title={userSpecialties?.length > 1 ? 'Specialties' : 'Specialty'}
            value={EducationUtils.mapToRemoveSpecialtyPrefix(userSpecialties).join(', ')}
            showWarningIcon={!specialtyMatch}
          />

          <div style={{ width: '100%' }}>
            <b style={{ color: Colors.neutral_600, fontSize: 20 }}>Experienced Procedures:</b>

            <RdhFdProcedures candidate={candidate} job={job} />

            <DnDaProcedures candidate={candidate} job={job} />
          </div>
        </div>
      </div>
    </div>
  );
};

const ProfessionalInfoSection = ({ title, value, showWarningIcon = false }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8 }}>
      <b style={{ color: Colors.neutral_600, fontSize: 20 }}>{title}:</b>
      {showWarningIcon ? <img src={WarningAlertIcon} alt="Warning Alert Icon" width={18} /> : null}
    </div>

    <span style={{ fontSize: 16, color: Colors.neutral_600 }}>{value}</span>
  </div>
);
